import React, { useContext, useState } from 'react';
import { StoreContext } from '../../context/store/storeContext';
import { Button } from 'antd';
import { useForm } from 'react-hook-form';
import { login } from '../../api';
import YFinput from '../elements/YFInput';
// import YFSubmitButton from "../elements/YFSubmitButton";
import { useCookies } from 'react-cookie';
// import { Spin } from "antd";
// import { LoadingOutlined } from "@ant-design/icons";

const SignInForm = ({ onChange, changeTab }) => {
    const { actions } = useContext(StoreContext);
    const { register, errors, handleSubmit } = useForm();
    // eslint-disable-next-line no-unused-vars
    const [cookies, setCookie, removeCookie] = useCookies(['SESSION']);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    //const Loading = <LoadingOutlined sytle={{ fontSize: 24 }} />;

    const onSubmit = (data) => {
        setLoading(true);
        login(data)
            .then((response) => {
                // update entry dialog status to false, it is need close and redirect to Profile information fill page
                actions.dialogAction.openEntryDialog(false);
                removeCookie('SESSION', { path: '/' });
                setCookie('SESSION', response, {
                    path: '/',
                });
                setLoading(false);
                const { token_type, access_token } = response;
                const token = `${token_type} ${access_token}`;
                actions.cookieAction.storeSession(token);
                window.location.reload(false);
            })
            .catch((error) => {
                setError(error);
                if (!error.errors) {
                    const msg = `${error.message}`;
                    changeTab({ title: 'Verification Alert', body: msg, type: 'warning' });
                }
                setLoading(false);
            });
    };

    const displayError = (param) => {
        if (param?.type === 'required') {
            return <span className="formFieldError">Please enter your password </span>;
        } else if (param?.type === 'minLength') {
            return <span className="formFieldError">Must be at least 8 characters. </span>;
        } else if (error.errors !== undefined) {
            return <span className="formFieldError"> {error.message} </span>;
        }
    };

    return (
        <form test_id="signin-form" className="entry-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="formFieldContainer">
                <YFinput
                    test_id="signin-email"
                    name="email"
                    type="text"
                    label="Email"
                    placeholder="Enter Email"
                    register={register({
                        required: true,
                        pattern:
                            /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    })}
                />
                {errors.email?.type === 'required' && (
                    <span className="formFieldError"> Please enter your email. </span>
                )}
                {errors.email?.type === 'pattern' && <span className="formFieldError"> Invalid email format. </span>}
            </div>

            <div className="formFieldContainer">
                <YFinput
                    test_id="signin-password"
                    name="password"
                    type="password"
                    label="Password"
                    placeholder="Enter Password"
                    register={register({ required: true, minLength: 8, maxLength: 32 })}
                />
                {displayError(errors.password)}
            </div>
            <Button htmlType="submit" test_id="signin-submit" loading={loading}>
                Sign In
            </Button>
            {/* {!loading ? (
        <YFSubmitButton test_id="signin-submit" label="Sign In" />
      ) : (
        <Spin test_id="signin-loading" indicator={Loading} />
      )} */}
            {/* <a className="login-form-forgot" onClick={onChange}>
        Forgot your password?
      </a> */}
            <Button test_id="signin-submit" className="btn-link" type="link" onClick={onChange}>
                Forgot your password?
            </Button>
        </form>
    );
};

export default SignInForm;
